import { render, staticRenderFns } from "./GuideBookPaperNextVersion.vue?vue&type=template&id=707b0efa"
import script from "./GuideBookPaperNextVersion.vue?vue&type=script&lang=js"
export * from "./GuideBookPaperNextVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports